export const SITE_COLORS = {
    filterOpen: { background: '#212121' },
    filterClose: { background: '#000000' },
    featureSite: { background: '#8e48fc' },
    typeSite: { background: '#0EC295' }
}